import { ReactNode } from 'react';

import CheckCircle from '@synapex/frontend-shared/icons/check-circle-32.svg?react';
import * as BotStart from '@synapex/shared2/bot-start';

import { CopyLink } from '@/true-fsd/shared/ui/CopyLink';
import { ButtonLink } from '@/true-fsd/shared/ui/ButtonLink';
import {
  accountPath,
  AdvertiserAccount,
  Invite,
} from '@/true-fsd/data/advertiser-account';

import classes from './CreateAccount.module.scss';

type RenderLayoutProps = {
  slotHeader: ReactNode;
  slotTitle: ReactNode;
  slotButtons: ReactNode;

  children: ReactNode;
};

export type CreateAccountCompleteProps = {
  RenderLayout: (p: RenderLayoutProps) => ReactNode;
  account: AdvertiserAccount;
  invite?: Invite;
  onCompleteClick?: () => void;
};
export const CreateAccountComplete = ({
  RenderLayout,
  account,
  invite,
  onCompleteClick,
}: CreateAccountCompleteProps) => {
  return (
    <RenderLayout
      slotHeader={
        <div className={classes.header}>
          <CheckCircle className={classes.completeIcon} />
          Завершение регистрации
        </div>
      }
      slotTitle={'Отлично! Вы создали аккаунт рекламодателя'}
      slotButtons={
        <ButtonLink
          variant={'primary'}
          to={accountPath(account)}
          onClick={onCompleteClick}
        >
          Завершить регистрацию
        </ButtonLink>
      }
    >
      {invite && (
        <CopyLink
          link={
            BotStart.telegramGetBotStartUrl(
              import.meta.env.VITE_BOT_USERNAME,
              BotStart.Invite,
              { inviteToken: invite.token },
            ).href
          }
        />
      )}
      <p className={classes.completeText}>
        Пригласите других участников, кто будет работать в данном аккаунте или
        сделайте это позже
      </p>
    </RenderLayout>
  );
};
